// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

export const splitArrayIntoChunks = ({ inputArray, itemsPerChunk }) =>
  inputArray.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / itemsPerChunk)
    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = []
    }
    resultArray[chunkIndex].push(item)
    return resultArray
  }, [])

/**
 * Iterate an array of items that returns promises in chunks. So it will
 * only have up to a maximum of the chunk size resolving at any one time.
 * NOTE: At the time of writing this function meets that requirement but it
 * is not as efficient because it completes 4 chunks then does the next 4
 * chunks.
 * @param {Array<Mixed>} arr
 * @param {number} chunkSize The max amount of resolving promises to be
 * active at any one time.
 * @param {Function} mapFunc This will be fired for all items in the array.
 * It should return a promise, else you may as well use a regular forEach loop.
 * @returns {Array<Mixed>}
 */
export const iteratePromisesInChunks = async function(arr, chunkSize, mapFunc) {
  var results = []
  for (var i = 0; i < arr.length; i += chunkSize) {
    var items = arr.slice(i, i + chunkSize)
    var temp = await Promise.all(items.map(mapFunc))
    temp.forEach(t => results.push(t))
  }
  return results
}
